<sd-6-17-1-drawer
  #drawer
  [label]="title | transloco"
  placement="end">
  <span
    slot="header"
    class="sd-headline sd-headline--size-lg">
    {{ title | transloco }}
  </span>

  <div class="filter-content">
    <div class="filter-templates">
      <div class="filter-templates-header">
        <label
          class="filter-templates-label"
          for="filter-templates-select">
          {{ filterTemplates | transloco }}
        </label>
        <sd-6-17-1-dropdown
          class="filter-templates-menu"
          distance="0"
          rounded
          hoist>
          <sd-6-17-1-button
            slot="trigger"
            variant="tertiary"
            [attr.aria-label]="filterTemplatesMenu | transloco">
            <sd-6-17-1-icon
              library="{{ iconLibrary }}"
              name="system/more-functions"></sd-6-17-1-icon>
          </sd-6-17-1-button>
          <sd-6-17-1-menu stay-open-on-select>
            <sd-6-17-1-menu-item
              sdCloseOnSelect
              (click)="openSaveTemplateDialog()">
              {{ newTemplate | transloco }}
            </sd-6-17-1-menu-item>
            @if (selectedTemplateId()) {
              <sd-6-17-1-menu-item>
                <sd-6-17-1-switch
                  [checked]="selectedTemplateAutoLoad()"
                  (sd-change)="onTemplateToggleChange()">
                  {{ defaultTemplateToggle | transloco }}
                  <sd-6-17-1-tooltip [content]="defaultTemplateToggleTitle | transloco">
                    <sd-6-17-1-icon
                      library="{{ iconLibrary }}"
                      name="system/info-circle"
                      slot="trigger"></sd-6-17-1-icon>
                  </sd-6-17-1-tooltip>
                </sd-6-17-1-switch>
              </sd-6-17-1-menu-item>
              <sd-6-17-1-menu-item
                sdCloseOnSelect
                (click)="openRenameTemplateDialog()">
                {{ renameTemplate | transloco }}
              </sd-6-17-1-menu-item>
              <sd-6-17-1-menu-item
                sdCloseOnSelect
                (click)="openDeleteTemplateDialog()">
                {{ deleteTemplate | transloco }}
              </sd-6-17-1-menu-item>
            }
          </sd-6-17-1-menu>
        </sd-6-17-1-dropdown>
      </div>
      <wct-filter
        class="filter-dropdown"
        [type]="FilterType.DROPDOWN"
        [multiValue]="false"
        [showLabel]="true"
        [filter]="templateFilter()"
        (selected)="changeTemplateSelection($event)"></wct-filter>
    </div>
    <sd-6-17-1-divider style="display: block; margin-bottom: 1.5em"></sd-6-17-1-divider>
    @if (filters.hasValue()) {
      @if (filters.value().length === 0) {
        <p class="sd-meta sd-meta--size-sm">{{ noFiltersAvailable | transloco }}</p>
      }

      @for (filter of filters.value(); track filterKey(filter)) {
        @if (filterKey(filter) !== FUNDS_FILTER_KEY) {
          <div class="filter-category">
          @if (filter) {
            <span class="filter-label">{{ filter.key }}</span>
          }

          <wct-filter
            class="filter-dropdown"
            [type]="componentType(filter)"
            [multiValue]="isMultiValue(filter)"
            [filter]="filtersWithPreselection().get(filterKey(filter))!"
            (selected)="setSelection(filterKey(filter), $event)"></wct-filter>
           </div>
         }
       }
     } @else if (filters.isLoading()) {
      <div class="full">
        <sd-6-17-1-loader color="primary"></sd-6-17-1-loader>
      </div>
    } @else if (filters.error()) {
      <div class="full">{{ filterLoadError | transloco }}</div>
    }
  </div>

  <div
    slot="footer"
    class="filter-footer">
    <sd-6-17-1-button
      variant="primary"
      class="save-button"
      [class.save-button--highlighted]="hasActiveFilters()"
      [disabled]="!hasActiveFilters()"
      (click)="onApplyClick()">
      {{ saveLabel() | transloco }}
    </sd-6-17-1-button>
    <sd-6-17-1-button
      class="reset-button"
      variant="secondary"
      size="md"
      [disabled]="!isDirty() && !hasActiveFilters()"
      (click)="discardOrResetClick()">
      {{ secondaryLabel() | transloco }}
    </sd-6-17-1-button>
  </div>
</sd-6-17-1-drawer>

<app-save-filter-template-dialog
  [nextTemplateName]="nextTemplateName()"
  [filterValues]="activeFilters()"
  (saved)="onTemplateSaved($event)"></app-save-filter-template-dialog>

<app-rename-filter-template-dialog
  [existingNames]="existingNamesForRename()"
  (renamed)="onTemplateRenamed($event)"></app-rename-filter-template-dialog>

<app-delete-filter-template-dialog
  [templateId]="selectedTemplateId()"
  [templateName]="selectedTemplateName()"
  (confirmed)="onTemplateConfirmedDelete()"></app-delete-filter-template-dialog>

